import { Injectable } from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class EmrPatientListService {

    private headers = new Headers({'Content-Type': 'application/json'});

    private ListRecordByunitId = webapi + 'mst_patient/listEMRPateintByUnitId/?';

    private AddRecord = webapi + 'mst_visit_brought_by/create/?';

    private ListRecordByStartEndDate = webapi + 'mst_patient/listEMRpatientbystartenddate?';

    private ListEMRVisitpatientlistbystartenddate = webapi + 'mst_visit/listEMRVisitpatientlistbystartenddate?';
    private GetRecord = webapi + 'mst_visit_brought_by/byvisitid/';


    constructor(private http: Http) {
    }

    getAllRecordServiceByUnitId(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any, searchType: any): Promise<any> {
        return this.http.get(this.ListRecordByunitId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&unitId=' + unitId + '&searchType=' + searchType)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    getAllEMRPatientByStartEndDate(currentPage: any, size: any, startdate: any, enddate: any, sort: any, col: any, unitid: any): Promise<any> {
        return this.http.get(this.ListRecordByStartEndDate + 'page=' + currentPage + '&size=' + size + '&startdate=' + startdate + '&enddate=' + enddate + '&sort=' + sort + '&col=' + col + '&unitid=' + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  getAllEMRVisitPatientListByStartEndDate(currentPage: any, size: any, enddate: any, sort: any, col: any, unitid: any): Promise<any> {
        return this.http.get(this.ListEMRVisitpatientlistbystartenddate + 'page=' + currentPage + '&size=' + size + '&enddate=' + enddate + '&sort=' + sort + '&col=' + col + '&unitid=' + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addService(user: any) {
        return this.http.post(this.AddRecord, JSON.stringify(user), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }


}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/emrsidebar/emr-patient-list/emr-patient-list.service.ts